import { LISTAR_CATDIAGNOSTICOS } from "../../types";

// eslint-disable-next-line import/no-anonymous-default-export
export default (state, action) => {
  switch (action.type) {
    case LISTAR_CATDIAGNOSTICOS:
      return {
        ...state,
        catDiagnosticos: action.payload,
      };
    default:
      return state;
  }
};
